interface Props {
  timestamp: string;
  narrative: string;
}

export default function CaseFile({ timestamp, narrative }: Props) {
  return (
    <div className="case-file">
      <div className="case-file-label">— Case File</div>
      <p className="case-narrative">
        <span className="time-stamp">{timestamp}</span>{" "}
        <span dangerouslySetInnerHTML={{ __html: narrative }} />
      </p>
    </div>
  );
}
